import { baseApi } from "./baseApi";

export const supportApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    sendSupport: builder.mutation<any, { message: string }>({
      query: (body) => ({
        url: "/support",
        method: "POST",
        body,
      }),
      invalidatesTags: ["Support"],
    }),
  }),
});

export const { useSendSupportMutation } = supportApi;
